import { render } from "./AddInquiryType.vue?vue&type=template&id=e1770060&scoped=true"
import script from "./AddInquiryType.vue?vue&type=script&lang=js"
export * from "./AddInquiryType.vue?vue&type=script&lang=js"

import "./AddInquiryType.vue?vue&type=style&index=0&id=e1770060&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1770060"]])

export default __exports__